// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { LectureSlide } from '../models';
import { LectureSlideCreate } from '../models';
import { LectureSlideEdit } from '../models';
import { Sort } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * LectureSlideApi - axios parameter creator
 * @export
 */
export const LectureSlideApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, slide_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            // verify required parameter 'slide_id' is not null or undefined
            if (slide_id === null || slide_id === undefined) {
                throw new RequiredError('slide_id','Required parameter slide_id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/lecture/{id}/slide/{slide_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"slide_id"}}`, encodeURIComponent(String(slide_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture slide.
         * @param {string} id 
         * @param {LectureSlideCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureSlideCreate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling create.');
            }
            const localVarPath = `/v1/lecture/{id}/slide/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {LectureSlideEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, slide_id: string, body?: LectureSlideEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            // verify required parameter 'slide_id' is not null or undefined
            if (slide_id === null || slide_id === undefined) {
                throw new RequiredError('slide_id','Required parameter slide_id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/lecture/{id}/slide/{slide_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"slide_id"}}`, encodeURIComponent(String(slide_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, slide_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            // verify required parameter 'slide_id' is not null or undefined
            if (slide_id === null || slide_id === undefined) {
                throw new RequiredError('slide_id','Required parameter slide_id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/lecture/{id}/slide/{slide_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"slide_id"}}`, encodeURIComponent(String(slide_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture slides.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sort.');
            }
            const localVarPath = `/v1/lecture/{id}/slide/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LectureSlideApi - functional programming interface
 * @export
 */
export const LectureSlideApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, slide_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LectureSlideApiAxiosParamCreator(configuration)._delete(id, slide_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture slide.
         * @param {string} id 
         * @param {LectureSlideCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureSlideCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureSlide> {
            const localVarAxiosArgs = LectureSlideApiAxiosParamCreator(configuration).create(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {LectureSlideEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, slide_id: string, body?: LectureSlideEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureSlide> {
            const localVarAxiosArgs = LectureSlideApiAxiosParamCreator(configuration).edit(id, slide_id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, slide_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureSlide> {
            const localVarAxiosArgs = LectureSlideApiAxiosParamCreator(configuration).get(id, slide_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture slides.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LectureSlideApiAxiosParamCreator(configuration).sort(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LectureSlideApi - factory interface
 * @export
 */
export const LectureSlideApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, slide_id: string, options?: any) {
            return LectureSlideApiFp(configuration)._delete(id, slide_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture slide.
         * @param {string} id 
         * @param {LectureSlideCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureSlideCreate, options?: any) {
            return LectureSlideApiFp(configuration).create(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {LectureSlideEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, slide_id: string, body?: LectureSlideEdit, options?: any) {
            return LectureSlideApiFp(configuration).edit(id, slide_id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture slide.
         * @param {string} id 
         * @param {string} slide_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, slide_id: string, options?: any) {
            return LectureSlideApiFp(configuration).get(id, slide_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture slides.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any) {
            return LectureSlideApiFp(configuration).sort(id, body, options)(axios, basePath);
        },
    };
};

/**
 * LectureSlideApi - object-oriented interface
 * @export
 * @class LectureSlideApi
 * @extends {BaseAPI}
 */
export class LectureSlideApi extends BaseAPI {
    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Delete lecture slide.
     * @param {string} id 
     * @param {string} slide_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureSlideApi
     */
    public _delete(id: string, slide_id: string, options?: any) {
        return LectureSlideApiFp(this.configuration)._delete(id, slide_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Create new lecture slide.
     * @param {string} id 
     * @param {LectureSlideCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureSlideApi
     */
    public create(id: string, body?: LectureSlideCreate, options?: any) {
        return LectureSlideApiFp(this.configuration).create(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Edit lecture slide.
     * @param {string} id 
     * @param {string} slide_id 
     * @param {LectureSlideEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureSlideApi
     */
    public edit(id: string, slide_id: string, body?: LectureSlideEdit, options?: any) {
        return LectureSlideApiFp(this.configuration).edit(id, slide_id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
     * @summary Get lecture slide.
     * @param {string} id 
     * @param {string} slide_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureSlideApi
     */
    public get(id: string, slide_id: string, options?: any) {
        return LectureSlideApiFp(this.configuration).get(id, slide_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Sort lecture slides.
     * @param {string} id 
     * @param {Array<Sort>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureSlideApi
     */
    public sort(id: string, body?: Array<Sort>, options?: any) {
        return LectureSlideApiFp(this.configuration).sort(id, body, options)(this.axios, this.basePath);
    }

}
